import React from 'react';

import { Category } from './types';

interface CategoryHeaderProps {
  category: Category;
  filteredProvidersCount: number;
  sortBy: 'rating' | 'name' | 'experience';
  filterVerified: boolean;
  filterPremium: boolean;
  filterLocation: string;
  onSortChange: (value: 'rating' | 'name' | 'experience') => void;
  onFilterVerifiedChange: (checked: boolean) => void;
  onFilterPremiumChange: (checked: boolean) => void;
  onFilterLocationChange: (location: string) => void;
}

const CategoryHeader: React.FC<CategoryHeaderProps> = ({
  category,
  filteredProvidersCount,
  sortBy,
  filterVerified,
  filterPremium,
  filterLocation,
  onSortChange,
  onFilterVerifiedChange,
  onFilterPremiumChange,
  onFilterLocationChange
}) => {
  return (
    <div 
      className="uk-section uk-light category-page-header"
      style={{
        background: 'linear-gradient(135deg, #20D3C7 0%, #17BCBA 100%)',
        padding: '80px 0 40px 0',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Elementos decorativos de fondo */}
      <div style={{
        position: 'absolute',
        top: '-50%',
        right: '-10%',
        width: '300px',
        height: '300px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        transform: 'rotate(45deg)'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '-30%',
        left: '-5%',
        width: '200px',
        height: '200px',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '50%'
      }}></div>
      
      <div className="uk-container uk-container-large">
        <div className="uk-grid uk-flex-middle" data-uk-grid>
          {/* Icono y título */}
          <div className="uk-width-1-4@m">
            <div style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                background: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '15px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.3)'
              }}>
                <i className={category.icon} style={{ 
                  fontSize: '28px',
                  color: 'white',
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
                }}></i>
              </div>
              <h1 className="uk-heading-medium" style={{ 
                color: 'white', 
                margin: 0,
                fontSize: '28px',
                fontWeight: '700',
                textShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}>
                {category.name}
              </h1>
            </div>
          </div>
          
          {/* Descripción */}
          <div className="uk-width-1-4@m">
            <p className="uk-text-lead" style={{ 
              color: 'rgba(255, 255, 255, 0.95)', 
              margin: 0,
              fontSize: '14px',
              lineHeight: '1.4',
              textShadow: '0 1px 2px rgba(0,0,0,0.1)'
            }}>
              Encuentra los mejores proveedores de {category.name.toLowerCase()} para tu proyecto
            </p>
          </div>
          
          {/* Contador de resultados */}
          <div className="uk-width-1-6@m uk-text-center@m">
            <div className="results-count" style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '12px 16px',
              borderRadius: '12px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              display: 'inline-block'
            }}>
              <div className="uk-text-large uk-text-bold" style={{ 
                color: 'white',
                fontSize: '16px',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}>
                {filteredProvidersCount} proveedores
              </div>
            </div>
          </div>
          
          {/* Filtros y Ordenamiento */}
          <div className="uk-width-1-3@m">
            <div className="uk-flex" style={{ gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
              {/* Filtro por Localidad */}
              <div style={{ position: 'relative', display: 'inline-block', minWidth: '160px' }}>
                <i className="fas fa-map-marker-alt" style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  zIndex: 1,
                  fontSize: '10px'
                }}></i>
                <select 
                  className="uk-select"
                  value={filterLocation}
                  onChange={(e) => onFilterLocationChange(e.target.value)}
                  style={{
                    padding: '6px 12px 6px 30px',
                    borderRadius: '20px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: '500',
                    minWidth: '160px',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    height: '36px',
                    lineHeight: '24px'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.6)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                    e.target.style.boxShadow = '0 4px 15px rgba(255, 255, 255, 0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                  }}
                >
                  <option value="" style={{ color: '#333', background: 'white' }}>Todas las localidades</option>
                  <option value="buenos-aires" style={{ color: '#333', background: 'white' }}>Buenos Aires</option>
                  <option value="cordoba" style={{ color: '#333', background: 'white' }}>Córdoba</option>
                  <option value="rosario" style={{ color: '#333', background: 'white' }}>Rosario</option>
                  <option value="mendoza" style={{ color: '#333', background: 'white' }}>Mendoza</option>
                  <option value="la-plata" style={{ color: '#333', background: 'white' }}>La Plata</option>
                  <option value="mar-del-plata" style={{ color: '#333', background: 'white' }}>Mar del Plata</option>
                  <option value="salta" style={{ color: '#333', background: 'white' }}>Salta</option>
                  <option value="tucuman" style={{ color: '#333', background: 'white' }}>Tucumán</option>
                  <option value="neuquen" style={{ color: '#333', background: 'white' }}>Neuquén</option>
                  <option value="bahia-blanca" style={{ color: '#333', background: 'white' }}>Bahía Blanca</option>
                </select>
              </div>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px',
                background: filterVerified ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.2)',
                color: filterVerified ? '#20D3C7' : 'white',
                borderRadius: '20px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                boxShadow: filterVerified ? '0 4px 15px rgba(255, 255, 255, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                height: '36px'
              }}>
                <input 
                  className="uk-checkbox" 
                  type="checkbox" 
                  checked={filterVerified}
                  onChange={(e) => onFilterVerifiedChange(e.target.checked)}
                  style={{ marginRight: '6px' }}
                />
                <i className="fas fa-check-circle" style={{ marginRight: '6px', fontSize: '10px' }}></i>
                Verificados
              </label>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 12px',
                background: filterPremium ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.2)',
                color: filterPremium ? '#FFD700' : 'white',
                borderRadius: '20px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(10px)',
                boxShadow: filterPremium ? '0 4px 15px rgba(255, 255, 255, 0.3)' : '0 2px 8px rgba(0,0,0,0.1)',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                height: '36px'
              }}>
                <input 
                  className="uk-checkbox" 
                  type="checkbox" 
                  checked={filterPremium}
                  onChange={(e) => onFilterPremiumChange(e.target.checked)}
                  style={{ marginRight: '6px' }}
                />
                <i className="fas fa-crown" style={{ marginRight: '6px', fontSize: '10px' }}></i>
                Premium
              </label>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <i className="fas fa-sort" style={{
                  position: 'absolute',
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  zIndex: 1,
                  fontSize: '10px'
                }}></i>
                <select 
                  className="uk-select"
                  value={sortBy}
                  onChange={(e) => onSortChange(e.target.value as any)}
                  style={{
                    padding: '6px 12px 6px 30px',
                    borderRadius: '20px',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: '500',
                    minWidth: '140px',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                    height: '36px',
                    lineHeight: '24px'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.6)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                    e.target.style.boxShadow = '0 4px 15px rgba(255, 255, 255, 0.2)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                  }}
                >
                  <option value="rating" style={{ color: '#333', background: 'white' }}>Por rating</option>
                  <option value="name" style={{ color: '#333', background: 'white' }}>Por nombre</option>
                  <option value="experience" style={{ color: '#333', background: 'white' }}>Por experiencia</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryHeader;
